import { render, staticRenderFns } from "./ContentViewSettingsLink.vue?vue&type=template&id=4762d47a&scoped=true&"
import script from "./ContentViewSettingsLink.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsLink.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsLink.vue?vue&type=style&index=0&id=4762d47a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4762d47a",
  null
  
)

export default component.exports